export const ApiEndpoints = {
    get: {
        timezoneEndpoint: "timezone",
        userAirlineEndpoint: "userairline",
        airPortsEndpoint: "airports",
        getAirlinesEndpoint: "getairlines",
        getAccount: "myaccount",
        sources: "sources",
        userdetails: "userdetails",
        getoverviewstats: "getoverviewstats",
        travisStatus: "travis/status",
    },
    post: {
        auth: "authtoken",
        ipUpdate:"ipupdate",
        mymarket: "mymarket",
        mymarketpage: "mymarketpage",
        getmarketgroup: "getmarketgroup",
        fetchAirline: "airlines",
        bulkMarketDelete: "market/bulkmarketsDelete",
        bulkMarketOnHold: "market/onholdBulk",
        bulkMarketResume: "market/bulkresume",
        codeExchange: "auth/code-exchange",
        travisSetup: "travis/setup",
        travisConnect: "travis/connect",
    },
    remove: {
        market: "market",
    },
    groupdelete: {
        market: "deletemarketgroup",
    },
}